import { UrbanDashboardConfig } from "../../components/urbanDashboard/types";

/**
 * Default configuration for the Urban Interface
 * These values will be used if no user configuration is provided
 */

const defaultConfig: UrbanDashboardConfig = {
  mapboxToken: process.env.REACT_APP_MAPBOX_TOKEN || "",
  mapboxStyle: process.env.REACT_APP_MAPBOX_STYLE_URL || "",
  basemapStyle:
    process.env.REACT_APP_BASEMAP_STYLES_MAPBOX_ID ||
    "cmgpavlo8000n01qxhpos8nnn",
  dataUrl:
    process.env.REACT_APP_DATA_URL ||
    "https://raw.githubusercontent.com/US-GHG-Center/urban_dashboard_data/main/data",
};

/**
 * Merges user configuration with default configuration
 * @param {Partial<UrbanDashboardConfig>} userConfig - User provided configuration
 * @returns {UrbanDashboardConfig} Merged configuration
 */
export const getConfig = (
  userConfig: Partial<UrbanDashboardConfig> = {}
): UrbanDashboardConfig => {
  return {
    ...defaultConfig,
    ...userConfig,
  };
};

interface ValidationResult {
  result: boolean;
  missingFields: string[];
}

/**
 * Validates the configuration
 * @param {UrbanDashboardConfig} config - Configuration to validate
 * @returns {UrbanDashboardConfig} Validation result with missing fields if any
 */
export const validateConfig = (
  config: UrbanDashboardConfig
): ValidationResult => {
  const requiredFields: (keyof UrbanDashboardConfig)[] = [
    "mapboxToken",
    "mapboxStyle",
    "basemapStyle",
    "dataUrl",
  ];

  const missingFields = requiredFields.filter(
    (field) =>
      config[field] === undefined ||
      config[field] === null ||
      config[field] === ""
  );

  if (missingFields.length > 0) {
    return { result: false, missingFields };
  }
  return { result: true, missingFields: [] };
};
